import React from "react";
import { useAuth0 } from "@auth0/auth0-react";

const Profile = () => {
  const { isAuthenticated, isLoading, logout, loginWithRedirect } = useAuth0();

  if (isLoading) {
    return <div>Loading ...</div>;
  }
  return (<>
    {isAuthenticated ? (
      // <div>
      //   {/* <img src={user?.picture} alt={user?.name} /> */}
      //   <h2>{user?.name}</h2>
      //   <p>{user?.email}</p>
      // </div>
      <button className="btn btn btn-secondary" onClick={() => logout({ logoutParams: { returnTo: window.location.origin } })}>
      Log Out
    </button>
    ) : <button onClick={() => loginWithRedirect() }>
    Log In
  </button>}
  {/* <button className="btn btn-light" onClick={() => window.print()}>
      Print
    </button> */}
    </>
  );
};

export default Profile;